export default __webpack_public_path__ + "static/media/Patients-Benefits.139bcb5d.png";